import React from "react";
import { useTranslation } from "react-i18next";
import { Filter, X } from "lucide-react";

export default function SearchFilterButtons({ onSearch, onClear, height = 38 }) {
    const { t } = useTranslation();
    const buttonStyle = {
        width: 52,
        height,
        minWidth: 52,
        borderRadius: 10,
        padding: 0,
    };

    return (
        <div className="d-inline-flex align-items-center gap-2 flex-shrink-0">
            <button
                type="button"
                className="btn btn-primary d-inline-flex align-items-center justify-content-center"
                style={buttonStyle}
                onClick={onSearch}
                aria-label={t("Search")}
                title={t("Search")}
            >
                <Filter size={18} color="#fff" strokeWidth={2.25} />
            </button>
            <button
                type="button"
                className="btn btn-secondary d-inline-flex align-items-center justify-content-center"
                style={buttonStyle}
                onClick={onClear}
                aria-label={t("Clear")}
                title={t("Clear")}
            >
                <X size={18} color="#fff" strokeWidth={2.5} />
            </button>
        </div>
    );
}
